import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {VetDoctorVetVisitType} from "../vet-doctor-vet-visit-type.model";

export class VetDoctorVetVisitTypeDgSearchResults extends GenericDgSearchResults {
  public results: VetDoctorVetVisitType[];

  constructor(total: number, results: VetDoctorVetVisitType[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

